module.exports = __webpack_public_path__ + "img/Daniella.Kahane2.df8d4b85.jpg";